/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { ItemBulkUpdateListItemDto } from './item-bulk-update-list-item.dto';

export const ItemBulkUpdateListItemMapper = entity<ItemBulkUpdateListItemDto>();
